var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTest = function SvgTest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15 17a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H17a2 2 0 0 1-2-2zm2 0v18h18V17zM43 17a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H45a2 2 0 0 1-2-2zm2 0v18h18V17zM45 43a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V48.255l4.735-5.135a1 1 0 0 0-1.47-1.356L65 45.305V45a2 2 0 0 0-2-2zm10.062 13.083L63 47.474V45H45v18h18V50.424l-7.129 7.731a1 1 0 0 1-1.393.075l-7.05-6.169a1 1 0 0 1 1.317-1.505zM15 45a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H17a2 2 0 0 1-2-2zm2 0v18h18V45z",
    clipRule: "evenodd"
  })));
};
export default SvgTest;